import { useQuery } from 'react-query';
import { useService } from 'shared/providers';
import { Category } from 'shared/types';

export function useCategory(categoryId: string) {
    const { parameterService } = useService();

    const { data, isLoading, isFetching } = useQuery<Category, Error>(['category', categoryId], () =>
        parameterService.getCategory(categoryId)
    );

    return { category: data, isLoading, isFetching } as const;
}
